import { inject } from '@angular/core';
import { ResolveFn } from '@angular/router';
import { ToasterService } from '@maersk-global/angular-shared-library';
import { catchError, of } from 'rxjs';
import { COMMON_ERROR_MESSAGE_UI } from '../constants/constants';
import { PanelVisibility } from '../models/payload';
import { SharedDataService } from '../services/shared-data.service';

export const UserConfigDataResolver: ResolveFn<PanelVisibility> = (route, state) => {
  const sharedService = inject(SharedDataService);
  const toasterService = inject(ToasterService);
  return sharedService.getTrackingPageVisibility().pipe(
    catchError(() => {
      toasterService?.showToast({
        message: COMMON_ERROR_MESSAGE_UI,
        type: 'error',
        position: 'top-center'
      });
      return of({} as PanelVisibility);
    })
  );
};
